export default __webpack_public_path__ + "static/media/cancel.e279a14f.svg";